import { useQuery } from '@tanstack/react-query';
import { api } from '@/utils/api';

/**
 * QUANTOS ACHADOS DA CURADORIA ESTÃO ABERTOS PARA QUEM ESTÁ NO PORTAL — o número ao lado de "Curadoria" no menu
 * (26/10/2026). A conta é do servidor (`GET /api/curadoria/contagem`, `contarAbertos`: o mesmo recorte da fila de cada
 * um). A chave `curadoria-contagem` é a que a fila e o "Reportar erro" já invalidam ao abrir ou fechar um achado.
 * Zero, ou a consulta falhou: sem número — o menu não inventa pendência.
 */
export function useCuradoriaAbertos(ligado = true): number {
  const { data } = useQuery({
    queryKey: ['curadoria-contagem'],
    queryFn: async () => (await api.get<{ abertos: number }>('/api/curadoria/contagem')).data.abertos,
    enabled: ligado,
    staleTime: 2 * 60_000,
  });
  return typeof data === 'number' && data > 0 ? data : 0;
}

/** O número ao lado do nome, no mesmo desenho dos selos do menu da gestão; recolhido, um ponto com o número em `sr-only`. */
export const classeDoNumeroDaCuradoria = (recolhido: boolean) =>
  recolhido ? 'absolute right-2 top-1.5 h-2 w-2 rounded-full bg-amber-500' : 'ml-auto rounded-full bg-amber-100 px-2 py-0.5 text-xs font-medium text-amber-800';
